import { BreadcrumbInfoItems } from 'src/components/SimpleBreadcrumb';

export const breadcrumb: BreadcrumbInfoItems = [
  {
    label: 'APLICATIVO',
    link: '/application',
  },
  {
    label: 'DESIGN DO APLICATIVO',
  },
];
